export const pl = {
  'ad.label': 'Reklama',
  'ad.sponsored_by': 'Sponsorowane przez {advertiser}',
  'ad.visit': 'Odwiedź',
  'cookies.preferences': 'Preferencje plików cookie',
  'cookies.title': 'Twoja prywatność pod Twoją kontrolą',
  'cookies.description': 'Używamy niezbędnej pamięci, aby Albambam działał. Analitykę lub marketing włączymy tylko za Twoją zgodą. Możesz ją wycofać w każdej chwili. Przeczytaj',
  'cookies.privacy_link': 'Politykę Prywatności',
  'cookies.close': 'Zamknij preferencje',
  'cookies.necessary': 'Niezbędne',
  'cookies.necessary_desc': 'Sesja, bezpieczeństwo, język i podstawowe preferencje.',
  'cookies.analytics': 'Analityka',
  'cookies.analytics_desc': 'Anonimowy pomiar użycia w celu ulepszenia usługi.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personalizacja reklam i pomiar kampanii.',
  'cookies.configure': 'Konfiguruj',
  'cookies.reject': 'Odrzuć opcjonalne',
  'cookies.save': 'Zapisz wybór',
  'cookies.accept': 'Akceptuj wszystkie',
  'lang.selector_label': 'Język',
  'lang.changed': 'Zmieniono język',
  'nav.home': 'Strona główna',
  'nav.categories': 'Kategorie',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Przyjaźń',
  'nav.upload': 'Prześlij',
  'nav.profile': 'Profil',
  'nav.login': 'Zaloguj się',
  'common.signed_in': 'Zalogowano',
  'common.error': 'Błąd',
  'topbar.search_placeholder': 'Szukaj filmów, twórców...',
  'legal.terms': 'Regulamin',
  'legal.privacy': 'Prywatność',
  'nav.admin': 'Administracja',
  'nav.logout': 'Wyloguj się',
  'admin.tab.payments': 'Płatności',
  'admin.payments.title': 'Płatności',
  'cats.title': 'Kategorie',
  'cats.all': 'Wszystkie',
  'cats.adult_title': 'Kategorie 18+',
  'cats.empty': 'Brak filmów w tej kategorii.',
  'friends.block_confirm': 'Zablokować tego znajomego? Nie będziecie już mogli rozmawiać ani widzieć się jako znajomi.',
  'friends.accepted': 'Jesteście teraz znajomymi!',
  'friends.title': 'Przyjaźń',
  'friends.subtitle': 'Tylko osoby, które obserwują się wzajemnie, zostają znajomymi i mogą rozmawiać prywatnie.',
  'friends.unread_count_label': '{n} wiadomości do przeczytania',
  'friends.blocked_users_title': 'Zablokowani użytkownicy',
  'friends.unblock_user': 'Odblokuj',
  'friends.requests_title': 'Prośby o czat',
  'friends.request_badge': 'Prośba',
  'friends.request_accept': 'Akceptuj',
  'friends.request_ignore': 'Ignoruj',
  'friends.empty_title': 'Brak znajomych',
  'friends.empty_subtitle': 'Obserwuj kogoś i zostań zaobserwowany, aby odblokować prywatny czat.',
  'friends.attach_image': 'Zdjęcie',
  'friends.shared_video_label': 'Udostępniono film',
  'friends.select_conversation': 'Wybierz znajomego, aby rozpocząć czat',
  'friends.block_user': 'Zablokuj',
  'friends.no_messages_yet': 'Brak wiadomości. Przywitaj się!',
  'friends.message_placeholder': 'Napisz wiadomość...',
  'section.trending': 'Na topie',
  'section.shorts': 'Shorts',
  'section.for_you': 'Dla Ciebie',
  'home.hero.badge': 'Witamy w Albambam',
  'home.hero.title_1': 'Krótkie filmy.',
  'home.hero.title_2': 'Prawdziwi twórcy.',
  'home.hero.subtitle': 'Oglądaj, udostępniaj i zarabiaj. Prześlij swoje filmy i odkrywaj nowe talenty w każdej kategorii.',
  'home.hero.cta_shorts': 'Oglądaj Shorts',
  'home.hero.cta_trending': 'Na topie',
  'home.shorts.see_all': 'Zobacz wszystkie',
  'home.empty.title': 'Brak filmów',
  'home.empty.subtitle': 'Gdy twórcy prześlą treści, pojawią się tutaj.',
  'live.send_diamonds': 'Wyślij diamenty',
  'live.buy': 'Kup',
  'live.chat': 'Czat',
  'live.type_message': 'Napisz wiadomość...',
  'live.send': 'Wyślij',
  'auth.success_google': 'Zalogowano przez Google',
  'auth.fail_google': 'Nieprawidłowa sesja Google',
  'auth.success_login': 'Zalogowano',
  'auth.success_register': 'Utworzono konto',
  'auth.login_tab': 'Zaloguj się',
  'auth.register_tab': 'Utwórz konto',
  'auth.email': 'Adres e-mail',
  'auth.password': 'Hasło',
  'auth.submit_login_loading': 'Logowanie...',
  'auth.submit_login': 'Zaloguj się',
  'auth.name': 'Imię',
  'auth.submit_register_loading': 'Tworzenie...',
  'auth.submit_register': 'Utwórz konto',
  'auth.or': 'lub',
  'legal.privacy_title': 'Polityka Prywatności',
  'search.title': 'Wyniki dla „{q}”',
  'search.count': '{n} filmów',
  'search.empty': 'Brak wyników.',
  'series.load_error': 'Nie udało się załadować serialu',
  'series.unlocked': 'Serial odblokowany',
  'series.purchase_error': 'Nie udało się rozpocząć zakupu',
  'series.restricted': 'Dostęp ograniczony',
  'series.configure_access': 'Skonfiguruj dostęp',
  'series.language_all': 'Wszystkie języki',
  'series.episode_count': '{n} odcinków',
  'series.buy': 'Kup serial',
  'series.filter_language': 'Filtruj według języka',
  'series.no_episodes': 'Nie opublikowano jeszcze żadnych odcinków.',
  'series.episode_number': 'Odcinek {n}',
  'legal.terms_title': 'Regulamin i Warunki',
  'lang.ca': 'Kataloński',
  'lang.en': 'Angielski',
  'lang.es': 'Hiszpański',
  'lang.fr': 'Francuski',
  'lang.de': 'Niemiecki',
  'lang.it': 'Włoski',
  'lang.eu': 'Baskijski',
  'lang.gl': 'Galicyjski',
  'lang.zh': 'Chiński',
  'lang.other': 'Inne',
  'lang.vi': 'Wietnamski',
  'lang.ja': 'Japoński',
  'lang.ko': 'Koreański',
  'lang.ru': 'Rosyjski',
  'lang.ro': 'Rumuński',
  'lang.ar': 'Arabski',
  'lang.tr': 'Turecki',
  'lang.pl': 'Polski',
  'lang.ms': 'Malajski',
  'lang.ta': 'Tamilski',
  'upload.series_title_error': 'Wpisz tytuł serialu',
  'upload.series_adult_category_error': 'Wybierz kategorię 18+ dla serialu',
  'upload.series_created': 'Serial utworzony',
  'upload.series_create_error': 'Nie udało się utworzyć serialu',
  'upload.err_file': 'Wybierz prawidłowy plik wideo',
  'upload.err_title': 'Ustaw tytuł',
  'upload.series_select_error': 'Wybierz lub utwórz serial',
  'upload.trailer_target_error': 'Wybierz film lub serial zwiastuna',
  'upload.price_error': 'Wprowadź prawidłową cenę co najmniej 0,50 EUR.',
  'upload.adult_category_error': 'Wybierz kategorię dla dorosłych',
  'upload.success': 'Film przesłany pomyślnie',
  'upload.title_h': 'Prześlij film',
  'upload.kind': 'Typ publikacji',
  'upload.kind_video': 'Samodzielny film',
  'upload.kind_episode': 'Odcinek serialu',
  'upload.kind_trailer': 'Publiczny zwiastun w Shorts',
  'upload.series': 'Serial',
  'upload.series_select': 'Wybierz serial',
  'upload.episode': 'Odcinek',
  'upload.series_new_title': 'Tytuł nowego serialu',
  'upload.series_create': 'Utwórz serial',
  'upload.series_adult': 'Serial 18+',
  'upload.series_premium': 'Serial premium',
  'upload.series_adult_category': 'Kategoria 18+ serialu',
  'upload.series_price': 'Cena za odcinek i pakiet (EUR)',
  'upload.trailer_for': 'Zwiastun przedstawia',
  'upload.trailer_select': 'Wybierz film lub serial',
  'upload.video_prefix': 'Film',
  'upload.file_label': 'Plik wideo (MP4, maks. 1GB)',
  'upload.file_pick': 'Kliknij, aby wybrać film',
  'upload.thumb_label': 'Miniatura (opcjonalnie)',
  'upload.video_title': 'Tytuł',
  'upload.description': 'Opis',
  'upload.category': 'Kategoria',
  'upload.is_short': 'Jest to Short (pionowy)',
  'upload.paid_video': 'Film płatny',
  'upload.adult_content': 'Treść 18+',
  'upload.video_language': 'Język filmu',
  'upload.individual_price': 'Cena za obejrzenie tego filmu (EUR)',
  'upload.paid_video_help': 'Widz kupuje stały dostęp tylko do tego filmu. Minimalna cena to 0,50 EUR.',
  'upload.adult_category': 'Kategoria dla dorosłych',
  'upload.uploading': 'Przesyłanie {n}%',
  'upload.submit': 'Prześlij film',
  'user.followers': 'obserwujący',
  'user.following': 'obserwowani',
  'user.follow': 'Obserwuj',
  'user.chat_open': 'Czatuj',
  'user.request_sent': 'Prośba wysłana',
  'user.send_message': 'Wyślij wiadomość',
  'user.followers_title': 'Obserwujący',
  'user.following_title': 'Obserwowani',
  'user.unfollow': 'Przestań obserwować',
  'user.request_title': 'Prośba o czat',
  'user.request_subtitle': 'Możesz wysłać tylko jedną wiadomość. Jeśli zaakceptuje prośbę, zostaniecie znajomymi i będziecie mogli rozmawiać.',
  'user.request_placeholder': 'Napisz swoją wiadomość...',
  'user.request_send': 'Wyślij prośbę',
  'shorts.login_for_like': 'Zaloguj się, aby polubić',
  'watch.share_copied': 'Skopiowano link',
  'watch.delete_confirm': 'Usunąć ten komentarz?',
  'ad.skip_in': 'Pomiń za {n}s',
  'ad.skip': 'Pomiń reklamę',
  'watch.share': 'Udostępnij',
  'friends.share_video': 'Udostępnij film',
  'friends.send': 'Wyślij',
  'watch.comments': 'Komentarze',
  'watch.write_comment': 'Napisz komentarz...',
  'watch.publish': 'Opublikuj',
  'watch.login_to_comment': 'Musisz się zalogować, aby komentować.',
  'watch.login_btn': 'Zaloguj się, aby komentować',
  'watch.no_comments': 'Brak komentarzy.',
  'watch.related': 'Powiązane',
  'nav.trending': 'Na topie',
  'friends.follow_option_only_follow': 'Obserwuj',
  'friends.follow_option_friends': 'Znajomi',
  'watch.like': 'Lubię to',
  'watch.views_short': '{n} wyświetleń',
  'shorts.empty.title': 'Brak Shorts',
  'shorts.empty.subtitle': 'Prześlij krótki film, aby rozpocząć sekcję.',
  'shorts.share': 'Udostępnij',
  'auth.continue_google': 'Kontynuuj przez Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Cena (€)',
  'upload.err_select': 'Wybierz film',
  'profile.upload_btn': 'Prześlij film',
  'profile.tab_videos': 'Moje filmy ({n})',
  'profile.tab_history': 'Historia',
  'profile.tab_recos': 'Rekomendacje',
  'profile.no_videos': 'Nie przesłałeś jeszcze żadnych filmów.',
  'profile.no_history': 'Nie obejrzałeś jeszcze żadnych filmów.',
  'profile.no_recos': 'Obejrzyj kilka filmów, aby otrzymywać rekomendacje.',
  'profile.likes': 'polubienia',
  'profile.views': 'wyświetlenia',
  'wallet.title': 'Portfel',
  'wallet.rate_label': 'Stawka',
  'wallet.min_label': 'Minimum wypłaty',
  'wallet.amount_label': 'Kwota do wypłaty',
  'wallet.withdraw_btn': 'Zażądaj wypłaty',
  'wallet.history_title': 'Historia żądań',
  'wallet.success': 'Żądanie utworzone',
  'wallet.bad_amount': 'Nieprawidłowa kwota',
  'wallet.per_view': '{rate} {cur}/wyświetlenie',
  'admin.title': 'Administracja',
  'admin.stats.users': 'Użytkownicy',
  'admin.stats.videos': 'Filmy',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Wyświetlenia',
  'admin.tab.videos': 'Filmy',
  'admin.tab.ads': 'Reklamy',
  'admin.tab.users': 'Użytkownicy',
  'admin.tab.withdrawals': 'Wypłaty',
  'admin.tab.config': 'Ustawienia',
  'admin.tab.translations': 'Tłumaczenia',
  'tbl.title': 'Tytuł',
  'tbl.creator': 'Twórca',
  'tbl.category': 'Kategoria',
  'tbl.type': 'Typ',
  'tbl.views': 'Wyświetlenia',
  'tbl.likes': 'Polubienia',
  'tbl.status': 'Status',
  'tbl.actions': 'Akcje',
  'tbl.placement': 'Umiejscowienie',
  'tbl.advertiser': 'Reklamodawca',
  'tbl.impressions': 'Wyśw.',
  'tbl.clicks': 'Kliknięcia',
  'tbl.active': 'Aktywny',
  'tbl.name': 'Nazwa',
  'tbl.email': 'E-mail',
  'tbl.role': 'Rola',
  'tbl.wallet': 'Portfel',
  'tbl.amount': 'Kwota',
  'tbl.date': 'Data',
  'tbl.user': 'Użytkownik',
  'video.video': 'Film',
  'video.short': 'Short',
  'action.show': 'Opublikuj',
  'action.hide': 'Ukryj',
  'action.delete_confirm_video': 'Usunąć film?',
  'ad.create_h': 'Utwórz reklamę',
  'ad.title_label': 'Tytuł',
  'ad.image_label': 'URL obrazu',
  'ad.target_label': 'URL docelowy',
  'ad.advertiser_label': 'Reklamodawca',
  'ad.placement_label': 'Umiejscowienie',
  'ad.placement.banner': 'Baner (strona)',
  'ad.placement.preroll': 'Pre-roll (przed filmem)',
  'ad.placement.overlay': 'Nakładka (w filmie)',
  'ad.active': 'Aktywna',
  'ad.create_btn': 'Utwórz',
  'ad.success_create': 'Reklama utworzona',
  'ad.delete_confirm': 'Usunąć reklamę?',
  'users.make_admin': 'Zrób adminem',
  'users.remove_admin': 'Usuń admina',
  'wd.approve': 'Zatwierdź',
  'wd.reject': 'Odrzuć',
  'wd.mark_paid': 'Oznacz jako opłacone',
  'wd.empty': 'Brak żądań',
  'cfg.title': 'Ustawienia płatności',
  'cfg.rate_label': 'Płatność za wyświetlenie ({cur})',
  'cfg.min_label': 'Minimum wypłaty ({cur})',
  'cfg.currency': 'Waluta',
  'cfg.save': 'Zapisz',
  'cfg.saved': 'Ustawienia zapisane',
  'trans.title': 'Języki i tłumaczenia',
  'trans.intro': 'Prześlij plik JSON z tłumaczeniami dla dowolnego kodu języka (np. ja, pt, zh). Plik musi zawierać płaskie mapowanie klucz → tekst.',
  'trans.code_label': 'Kod języka (np. ja, pt-BR, zh)',
  'trans.name_label': 'Nazwa (w tym języku)',
  'trans.file_label': 'Plik JSON z tłumaczeniami',
  'trans.upload': 'Prześlij',
  'trans.uploaded': 'Tłumaczenia zapisane',
  'trans.delete': 'Usuń',
  'trans.delete_confirm': 'Usunąć ten język?',
  'trans.builtin': 'Wbudowany',
  'trans.custom': 'Niestandardowy',
  'trans.empty_custom': 'Brak niestandardowych języków.',
  'common.cancel': 'Anuluj',
  'common.loading': 'Ładowanie...',
  'common.too_fast': 'Za szybko, proszę chwilę poczekać',
  'time.few_seconds': 'kilka sekund temu',
  'time.min': '{n} min temu',
  'time.h': '{n} godz. temu',
  'time.d': '{n} dni temu',
  'time.w': '{n} tyg. temu',
  'time.mo': '{n} mies. temu',
  'time.y': '{n} lat temu',
  'brand.tagline': 'Krótkie filmy. Prawdziwi twórcy.',
  'live.section': 'Na żywo',
  'live.start': 'Rozpocznij transmisję na żywo',
  'live.end': 'Zakończ transmisję na żywo',
  'live.join': 'Dołącz do transmisji na żywo',
  'live.chat_placeholder': 'Napisz wiadomość...',
  'live.diamond': 'Diament',
  'live.buy_access': 'Kup dostęp',
  'live.save_recording': 'Zapisz nagranie',
};
